/**
 * Encode an email address for use as a Firebase RTDB path segment.
 * RTDB paths cannot contain: . $ # [ ] /
 * encodeURIComponent handles # $ [ ] / but NOT dots.
 * We also explicitly handle + for plus-addressing (user+tag@gmail.com).
 */
export function encodeEmailForRTDB(email) {
    return encodeURIComponent(email).replace(/\./g,'%2E')
}

/**
 * Decode an RTDB-encoded email back to its original form.
 */
export function decodeEmailFromRTDB(encoded) {
    return decodeURIComponent(encoded)
}
